import GlobalState from "../../../../../shared/utilities/globalState";
import {
  boundaryCreatedGA,
  confirmationGA,
  confirmationPasswordGA,
  itemIsSaved
} from "../../analytics/ga";

const triggerSaveDataGA = () => {
  const { boundary, flow, save } = GlobalState.get("analyticsData") || {};

  if (save) {
    itemIsSaved(save.itemType, save.itemId);
  } else if (boundary) {
    boundaryCreatedGA(boundary.source, flow);
  }
};

const triggerConfirmationModalOpenGA = analyticsData => {
  const {
    boundary,
    confirmationModalScenario,
    flow,
    save,
    source,
    userId,
    userType
  } = analyticsData;

  if (confirmationModalScenario === "setPassword") {
    confirmationPasswordGA.setPasswordConfirmationModalOpens(source, flow);
  } else if (save) {
    confirmationGA.confirmationModalOpensSaved(source, flow, userType, userId);
  } else if (boundary) {
    confirmationGA.confirmationModalOpensBoundary(boundary.source, flow);
  } else if (flow) {
    confirmationGA.confirmationModalOpens(source, flow, userType, userId);
  }
};

const triggerConfirmationModalCloseGA = analyticsData => {
  const {
    boundary,
    confirmationModalScenario,
    flow,
    save,
    source,
    userId,
    userType
  } = analyticsData;

  if (confirmationModalScenario === "setPassword") {
    confirmationPasswordGA.setPasswordConfirmationModalIsClosed(source, flow);
  } else if (save || source === "save") {
    confirmationGA.confirmationModalIsClosedSaved(
      source,
      flow,
      userType,
      userId
    );
  } else if (boundary) {
    confirmationGA.confirmationModalIsClosedBoundary(boundary.source, flow);
  } else if (flow) {
    confirmationGA.confirmationModalIsClosed(source, flow);
  }
};

const triggerConfirmationModalGA = action => {
  if (localStorage.getItem("analytics")) {
    const { flow, source, userId, userType } = JSON.parse(
      localStorage.getItem("analytics") || {}
    );

    const confirmationModalScenario = localStorage.getItem(
      "confirmationModalScenario"
    );

    const { boundary, save } = GlobalState.get("analyticsData") || {};
    const analyticsData = {
      source,
      flow,
      userType,
      userId,
      save,
      boundary,
      confirmationModalScenario
    };

    if (action === "open") {
      triggerConfirmationModalOpenGA(analyticsData);
    } else if (action === "close") {
      triggerConfirmationModalCloseGA(analyticsData);
    }
  }
};

export { triggerConfirmationModalGA, triggerSaveDataGA };
